<template>
  <div class="report-statistics-item atb-flex atb-flex-column">
    <div class='search'>
      <el-form :inline="true" :model="search" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
        <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
          <el-popover
            placement="bottom-start"
            width="420"
            popper-class="popper-tree declare-dep"
            @hide="handledHide"
            trigger="click">
            <!-- <el-input v-model="searchDep" placeholder="请输入部门名称搜索" clearable></el-input> -->
            <el-tree
              :props="defaultProps"
              :data="treeData"
              show-checkbox
              node-key='id'
              ref="tree"
              highlight-current
              :default-expanded-keys="expandedData"
              @check="handleCheckChange">
            </el-tree>
            <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item class="flex-form-item" label="上级" v-if="id == 0">
          <selecter v-model="searchParam.superiorNo" placeholder="输入工号或姓名查询" :name="searchParam.superiorName"></selecter>
        </el-form-item>
        <el-form-item class="flex-form-item" label="姓名">
          <el-input v-model="searchParam.wkName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="年份" v-if="id == 1">
          <el-date-picker
            v-model="searchParam.date"
            type="year"
            format="yyyy 年"
            placeholder="选择日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="月份" v-else-if="id == 2">
          <el-date-picker
            v-model="searchParam.date"
            type="month"
            format="yyyy 年 MM 月"
            placeholder="选择日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="周" v-else-if="id == 3">
          <el-date-picker
            v-model="searchParam.date"
            type="week"
            format="yyyy 年 WW 周"
            placeholder="选择日期"
            :picker-options="{firstDayOfWeek: 1}"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="日期" v-else-if="id == 4">
          <el-date-picker
            v-model="searchParam.date"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="选择日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="数据权限" prop="authType">
          <el-select v-model="searchParam.authType" placeholder="">
            <el-option v-for="item in authTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="$auth(that, 'YearPlanExport','OEC.ManageConsole.ReportExport')"> -->
        <el-form-item>
          <el-button type="export" @click="exportExcel">导出</el-button>
        </el-form-item>
        <el-form-item v-if="id !== 0">
          <el-button type="export" @click="showBatchExportDate">批量导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='table-content'>
      <vxe-table
        stripe
        class='atb-table'
        border='inner'
        height='100%'
        auto-resize
        :data="tableData"
        ref="table"
        highlight-hover-row
        highlight-current-row
        @cell-dblclick="goDetail"
        @checkbox-all="unHandleSelectAll"
        @checkbox-change="unHandleSelectChange"
        :seq-config="{ seqMethod }"
      >
        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column type='seq' width='60' title="序号"></vxe-table-column>
        <template v-if="id == 0">
          <vxe-table-column field="wkNo" width="100" title="工号"></vxe-table-column>
          <vxe-table-column field="wkName" width="120" title="姓名"></vxe-table-column>
          <vxe-table-column field="superiorNo" width="120" title="上级工号"></vxe-table-column>
          <vxe-table-column field="superiorName" width="100" title="上级姓名"></vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="220"></vxe-table-column>
          <vxe-table-column field="isYearPlan" width="80" title="年"></vxe-table-column>
          <vxe-table-column field="isMonthWork" width="80" title="月"></vxe-table-column>
          <vxe-table-column field="isWeekWork" width="80" title="周"></vxe-table-column>
          <vxe-table-column field="isDayWork" width="80" title="日"></vxe-table-column>
          <vxe-table-column field="isPeriodResult" width="130" title="综合考核有下级"></vxe-table-column>
          <vxe-table-column field="isPeriodSettingYear" width="130" title="年计划考核类型"></vxe-table-column>
          <vxe-table-column field="isPeriodSettingMonth" width="140" title="员工绩效考核类型"></vxe-table-column>
        </template>
        <template v-else>
          <vxe-table-column field="resWkNo" width="80" title="工号"></vxe-table-column>
          <vxe-table-column field="resWkName" width="120" title="姓名"></vxe-table-column>
          <vxe-table-column field="department" min-width="220" title="部门"> </vxe-table-column>
          <vxe-table-column field="title" title="标题" min-width="150"></vxe-table-column>
          <vxe-table-column field="status" title="状态" width="150">
            <template #default="{ row }">
              <el-tag type="complete" effect="dark" v-if="row.status">{{ row.status }}</el-tag>
            </template>
          </vxe-table-column>
        </template>
      </vxe-table>
    </div>
    <div class='page-con atb-flex atb-flex-justify-end'>
      <vxe-pager
        background
        :current-page.sync="page.PageIndex"
        :page-size.sync="page.PageSize"
        :total="total"
        height="100%"
        @page-change="handlePageChange"
        :page-sizes="[10, 30, 50, 100, 500]"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'Total']"
      >
      </vxe-pager>
    </div>
    <common-dialog ref="exportDialog" title="日期范围选择" class="report-export-date" width="530px" showClose :appendBody="true">
      <template slot="content">
        <el-form :inline="true" :rules="dialogRules" :model="exportParams" class="atb-input" ref="dialogForm">
          <el-form-item label="日期" prop="dateRange">
            <el-date-picker
              v-model="exportParams.dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="btn-wrap">
          <el-button type="save" class="btn" @click="batchExportExcel">导出</el-button>
          <el-button type="clear" class="btn" @click="$refs.exportDialog.hide()">关闭</el-button>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils';
  import {
    getWeekNumber,
  } from 'element-ui/src/utils/date-util';
  export default {
    name: "ReportItem",
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    props: {
      listUrl: String,
      exportUrl: String,
      label: String,
      statusData: {
        type: Array,
        default: () => ([])
      },
      treeData: {
        type: Array,
        default: () => ([])
      },
      expandedData: {
        type: Array,
        default: () => ([])
      },
      id: Number,
      currentTab: Number
    },
    data() {
      return {
        searchParam: {
          wkNo: '',
          wkName: '',
          superiorNo: '',
          superiorName: '',
          loginWkNo: '',
          date: new Date(),
          isSub: true,
          authType: 0
        },
        exportParams: {
          dateRange: '',
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],

        statusData:[],
  
        that: this,
        wkName: '',
        firstLoad: true,

        toUrl: '',

        defaultProps: {
          children: 'children',
          label: 'label'
        },
        department: '',
        departmentNo: '',
        dialogRules: {
          dateRange: [
            { required: true, message: '请选择日期', type: 'array', trigger: 'change' }
          ]
        },
        authTypeList: [
          { label: '直属下级', value: 0 },
          { label: '全部下级', value: 1 },
          { label: '数据权限', value: 2 },
          { label: '全部', value: 3 },
        ]
      }
    },
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.searchParam.loginWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
    },

    methods: {
      // 格式化序列号
      seqMethod({ rowIndex }) {
        return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
      },
      getList(page) {
        this.page.PageIndex = page || this.page.PageIndex;
        let param = Object.assign({ departmentNo: this.departmentNo }, this.searchParam, this.page);
        if (this.searchParam.date) {
          let dateObj  = this.searchParam.date;
          let year = dateObj.getFullYear();
          let month = dateObj.getMonth() + 1;
          let week = getWeekNumber(dateObj);
          let date = this.formatDate(dateObj, 'yyyy-MM-dd');
          if (this.id == 1) { // 年
            param = { ...param, year };
          } else if (this.id == 2) { // 月
            param = { ...param, year, month };
          } else if (this.id == 3) { // 周
            param = { ...param, year, week };
          } else if (this.id == 4) { // 日
            param = { ...param, date };
          }
        }
        this.$ajax.post(this.listUrl, param).then((res) => {
          this.tableData = res.data && res.data.rows;
          this.total = res.data && res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
        this.currentIndex = item.index;
        this.getList(1);
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      exportExcel() {
        if (this.id == 0) {
          let select = this.$refs.table.getCheckboxRecords();
          const selectNo = select.map(val => val.wkNo);
          let param = Object.assign({ departmentNo: this.departmentNo, ExportWkNos: selectNo }, this.searchParam, this.page);
          this.$ajax.post(this.exportUrl, param, {ignore: true, responseType: 'blob'}).then((res) => {
            if (res.data.type == 'application/json') {
              var reader = new FileReader();
              reader.onload = () => {
                var content = reader.result;//内容就在这里
                let json = JSON.parse(content)
                this.$message.error(json.message)
              };
              reader.readAsText(res.data);
            } else {
              const filename = `权限统计.xlsx`;
              this.exportFile(filename, res.data);
            }
          });
        } else {
          this.dateExport();
        }
      },
      dateExport() {
        let select = this.$refs.table.getCheckboxRecords();
        const selectNo = select.map(val => val.resWkNo);
        let param = Object.assign({ departmentNo: this.departmentNo, ExportWkNos: selectNo }, this.searchParam, { date: undefined }, this.page);
        let fileName = '';

        let start = this.searchParam.date;
        let end = this.searchParam.date;
        let startYear = start.getFullYear();
        let endYear = end.getFullYear();
        let startMonth = start.getMonth() + 1;
        let endMonth = end.getMonth() + 1;
        let startWeek = getWeekNumber(start);
        let endWeek = getWeekNumber(end);
        let startDate = this.formatDate(start, 'yyyy-MM-dd');
        let endDate = this.formatDate(end, 'yyyy-MM-dd');
        if (this.id == 1) { // 年
          param = { ...param, startYear, endYear };
          fileName = `${startYear}年`;
        } else if (this.id == 2) { // 月
          param = { ...param, startYear, endYear, startMonth, endMonth };
          fileName = `${startYear}年${startMonth}月`;
        } else if (this.id == 3) { // 周
          param = { ...param, startYear, endYear, startWeek, endWeek };
          fileName = `${startYear}年${startWeek}周`;
        } else if (this.id == 4) { // 日
          param = { ...param, startDate, startDate, endDate };
          let startDay = this.formatDate(start, 'yyyy年MM月dd日');
          fileName = startDay;
        }
        
        if (this.id == 3 || this.id == 4) {
          this.$ajax.post(this.exportUrl, param).then((res)=>{
            if(res.code === 0){
              this.$refs.exportDialog.hide();
              this.$router.push({
                path: '/manage/export-task/index',
              });
            }
          }).catch(() => {});
        } else {
          this.$ajax.post(this.exportUrl, param, {ignore: true, responseType: 'blob'}).then((res) => {
            if (res.data.type == 'application/json') {
              var reader = new FileReader();
              reader.onload = () => {
                var content = reader.result;//内容就在这里
                let json = JSON.parse(content)
                this.$message.error(json.message)
              };
              reader.readAsText(res.data);
            } else {
              const filename = `${fileName}${this.label}统计.xlsx`;
              this.exportFile(filename, res.data);
              this.$refs.exportDialog.hide();
            }
          });
        }
        
      },

      showBatchExportDate(){
        this.exportParams.dateRange = [];
        this.$refs.exportDialog.show();
      },
      batchExportExcel() {
        let select = this.$refs.table.getCheckboxRecords();
        const selectNo = select.map(val => val.resWkNo);
        let param = Object.assign({ departmentNo: this.departmentNo, ExportWkNos: selectNo }, this.searchParam, { date: undefined }, this.page);
        let fileName = '';
        this.$refs['dialogForm'].validate((valid) => {
          if (valid) {
            if (this.exportParams.dateRange && this.exportParams.dateRange.length > 0) {
              let start = this.exportParams.dateRange[0];
              let end = this.exportParams.dateRange[1];
              let startYear = start.getFullYear();
              let endYear = end.getFullYear();
              let startMonth = start.getMonth() + 1;
              let endMonth = end.getMonth() + 1;
              let startWeek = getWeekNumber(start);
              let endWeek = getWeekNumber(end);
              let startDate = this.formatDate(start, 'yyyy-MM-dd');
              let endDate = this.formatDate(end, 'yyyy-MM-dd');
              if (this.id == 1) { // 年
                param = { ...param, startYear, endYear };
                fileName = `${startYear}年`;
                if (startYear !== endYear) {
                  fileName += ` - ${endYear}年`;
                }
              } else if (this.id == 2) { // 月
                param = { ...param, startYear, endYear, startMonth, endMonth };
                fileName = `${startYear}年${startMonth}月`;
                if (startYear !== endYear || startMonth !== endMonth) {
                  fileName += ` - ${endYear}年${endMonth}月`;
                }
              } else if (this.id == 3) { // 周
                param = { ...param, startYear, endYear, startWeek, endWeek };
                if ((startYear === endYear && startWeek > endWeek) || (startDate !== endDate && startYear === endYear && startWeek === endWeek)) {
                  param.startYear--;
                }
                fileName = `${startYear}年${startWeek}周`;
                if (startYear !== endYear || startWeek !== endWeek) {
                  fileName += ` - ${endYear}年${endWeek}周`;
                }
              } else if (this.id == 4) { // 日
                param = { ...param, startDate, startDate, endDate };
                let startDay = this.formatDate(start, 'yyyy年MM月dd日');
                let endDay = this.formatDate(end, 'yyyy年MM月dd日');
                fileName = startDay;
                if (startDay !== endDay) {
                  fileName += ` - ${endDay}`;
                }
              }
            }
            
            if (this.id == 3 || this.id == 4) {
              this.$ajax.post(this.exportUrl, param).then((res)=>{
                if(res.code === 0){
                  this.$refs.exportDialog.hide();
                  this.$router.push({
                    path: '/manage/export-task/index',
                  });
                }
              }).catch(() => {});
            } else {
              this.$ajax.post(this.exportUrl, param, {ignore: true, responseType: 'blob'}).then((res) => {
                if (res.data.type == 'application/json') {
                  var reader = new FileReader();
                  reader.onload = () => {
                    var content = reader.result;//内容就在这里
                    let json = JSON.parse(content)
                    this.$message.error(json.message)
                  };
                  reader.readAsText(res.data);
                } else {
                  const filename = `${fileName}${this.label}统计.xlsx`;
                  this.exportFile(filename, res.data);
                  this.$refs.exportDialog.hide();
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      
      exportFile(name, data) {
        let url = window.URL.createObjectURL(data)
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = name
        a.click()
        window.URL.revokeObjectURL(url);
      },

      handlePageChange({currentPage}){
        this.getList(currentPage);
      },

      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(data, checked){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
      },

      handledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department="";
          }
        });
      },


      goBack() {
        this.$router.go(-1); //根据其需求，回退到指定地址
        this.$store.commit('common/backNavList',{url: this.toUrl});
      }
    },
    watch: {
      currentTab: {
        handler(val) {
          if (val === this.id) {
            this.getList();
          }
        },
        immediate: true
      },
      department: {
        handler(val){
          if(!val){
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate: true
      }
    }
  }
</script>
<style lang="scss">
  .report-statistics-item {
    height: 100%;
    flex: 1;
  }
  .report-export-date {
    .el-date-editor.el-input__inner {
      width: 420px;
    }
    .btn-wrap {
      text-align: right;
    }
    .el-button {
          width: 110px;
          border-radius: 10px;
      }
    .el-button.el-button--save {
      color: #ffffff;
      background-color: #22b6a1;
      border-color: #22b6a1;
    }
  }
</style>